<template>
  <div class="summer-container">
    <img src="~@/assets/img/summer/upload.jpg">
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.summer-container{
  width: 100%;
  margin: 0 auto;
  img{
    width: 100%;
    height: auto;
  }
}
</style>
